import React from 'react';
import { Link } from 'react-router-dom';
import { FaLock, FaHome } from 'react-icons/fa';
import './UnauthorizedPage.css';

const UnauthorizedPage = () => {
  return (
    <div className="unauthorized-container">
      <div className="unauthorized-background">
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
          <div className="shape shape-5"></div>
        </div>
        <div className="background-glow"></div>
      </div>

      <div className="unauthorized-content">
        <div className="icon-section">
          <div className="modern-lock">
            <FaLock className="lock-icon" />
            <div className="icon-glow"></div>
          </div>
        </div>

        <div className="text-section">
          <div className="title-wrapper">
            <h1>Access Restricted</h1>
            <div className="title-underline"></div>
          </div>
          <p className="main-message">
            Oops! This area is off-limits for your current access level.
          </p>
          <p className="sub-message">
            Don't worry! You can head back to safety or contact your administrator if you think this is a mistake.
          </p>
        </div>

        <div className="action-section">

          <Link to="/" className="action-btn secondary-btn">
            <FaHome className="btn-icon" />
            <span className="btn-text">Back to Home</span>
          </Link>
        </div>

        <div className="status-section">
          <div className="status-indicator">
            <div className="status-pulse"></div>
            <div className="status-dot"></div>
            <span>Unauthorized Access Attempt</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;